import React from "react";
import MapPin from "../../../Icons/MapPin";
import { MapPoint, TourData } from "../../../../Types";
import {
  UseAssetsQuery,
  UseDownloadAsset,
} from "../../../../api/calls/Queries";
import { useCurrentSceneStore } from "../../../../api/Zustand";
import { getLanguageFile } from "../../../common/GetLanguageFile";
import { navigateWithLocksCheck } from "../exp-spots/ViewerWaypoint";
import { useViewerMapStore } from "../../../../state management/zustand/viewer-stores";
import { useCompassHeadingStore } from "../../../../state management/zustand/gl-stores";

const OpenMap = (props: { tourData: TourData; tourID: number }) => {
  const { data: imageList } = UseAssetsQuery(props.tourID, 2);

  const viewerMap = useViewerMapStore();

  const { currentSceneID, setCurrentSceneID } = useCurrentSceneStore();

  const currentScene = React.useMemo(() => {
    return props.tourData.scenes.find((one) => one.id === currentSceneID);
  }, [currentSceneID, props.tourData.scenes]);

  const currentMap = React.useMemo(() => {
    return props.tourData.maps?.find((one) => one.id === currentScene?.map);
  }, [props.tourData.maps, currentScene]);

  const { data: imageBlob, isLoading } = UseDownloadAsset(
    imageList?.find((one) => one.assetId === currentMap?.assetId)?.assetKeyFull
  );

  const ref = React.useRef<HTMLDivElement>(null);

  const [width, setWidth] = React.useState<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });

  React.useEffect(() => {
    if (!ref.current) return;

    const resizeObserver = new ResizeObserver((e) => {
      const target: HTMLDivElement = e[0].target as HTMLDivElement;

      setWidth({
        x: target?.offsetWidth,
        y: target?.offsetHeight,
      });
    });
    resizeObserver.observe(ref.current);
  }, [ref]);

  return (
    <div className="map" ref={ref}>
      <div
        style={{
          position: "relative",
          height: "fit-content",
        }}
        // className="bg"
      >
        <button id="close" onClick={() => viewerMap.setClosed()}>
          {getLanguageFile("generics.close")}
        </button>

        {currentMap?.points?.map((p) => (
          <MapPinElement
            key={p.target + p.pos.x * p.pos.y}
            p={p}
            tourData={props.tourData}
          ></MapPinElement>
        ))}

        {/* <div
          style={{
            position: "absolute",
            background: "red",
            width: 30,
            height: 30,
            zIndex: 3,
          
            left

          }}
        /> */}

        {/* <Draggable bounds="parent"> */}
        {/* <div
          style={{
            position: "absolute",
            background: "red",
            width: 30,
            height: 30,
            zIndex: 3,
          }}
        /> */}
        {/* </Draggable> */}
        <img src={imageBlob} className="map-img" alt=" "></img>
      </div>
    </div>
  );
};

const MapPinElement = (props: { p: MapPoint; tourData: TourData }) => {
  const targetScene = React.useMemo(() => {
    return props.tourData.scenes.find((one) => one.id === props.p.target);
  }, [props.p.target, props.tourData.scenes]);

  const position: { x: number; y: number } = React.useMemo(() => {
    const pos = props.p.pos;

    return { x: pos.x * 100, y: pos.y * 100 };
  }, [props.p.pos]);

  const navigateFn = React.useCallback((id: string | number) => {
    const { currentSceneID } = useCurrentSceneStore.getState();

    if (currentSceneID === id) return;
    else navigateWithLocksCheck(id as number);
  }, []);

  const isThisScene = React.useMemo(() => {
    const { currentSceneID } = useCurrentSceneStore.getState();

    return targetScene?.id === currentSceneID;
  }, [targetScene?.id]);

  const { headingDeg } = useCompassHeadingStore();

  if (targetScene)
    return (
      <>
        {isThisScene && (
          <div
            className="cone"
            style={{
              left: `${position.x}%`,
              top: `${position.y}%`,

              transform: `translate(-50%, -50%) rotate(${
                targetScene.north + headingDeg
              }deg)`,
            }}
          ></div>
        )}
        <div
          className={`viewer-map-pin ${isThisScene ? " current" : ""}`}
          style={{
            left: `${position.x}%`,
            top: `${position.y}%`,
          }}
          onClick={() => navigateFn(targetScene.id)}
        >
          <div>
            <MapPin width={"100%"} height={"100% "}></MapPin>
          </div>

          {!isThisScene && (
            <div className="label">
              <p>{targetScene.title}</p>
            </div>
          )}
        </div>
      </>
    );
};

export default OpenMap;

//   position: absolute;
//   max-width: 800px;
//   padding: 2rem;
//   left: 50%;
//   top: 50%;
//   transform: translate(-50%, -50%);
//   box-sizing: border-box;
//   z-index: 10;
//   background-color: #fffd;
//   border: 2px solid #222;
//   backdrop-filter: blur(3px);
//   font-size: 1rem;
//   color: #222;
//   transition: 150ms;
//   max-height: 80%;
//   display: flex;
//   flex-direction: column;
